module.exports = {
	"INLINE": "Test",
	"nav_home": "Accueil",
	"nav_menu": "Ementa",
	"nav_about": "Restaurant",
	"nav_wines": "Vins",
	"nav_suggestions": "Suggestions",
	"nav_events": "Evénements",
	"nav-feedback": "Votre opinion",
	"nav-pickly": "À propos de Pickly",
	"follow_text": "Suivez-nous",
	"desktop_languages": "Langues",
	"intro_default_option": "Filtrez le menu par:",
	"suggested_extras": "Accompagnements suggérés",
	"suggested_wines": "Vins suggérés",
	"cta_title": "Voir notre sélection de",
	"cta_btn": "Vue",
	"related_products": "Produits similaires",
	"error_home_link": "Retour au début",
	"error_home_title1": "Hmm ... c'est gentil",
	"error_home_title2": "La page que vous cherchez n'a pas pu être trouvée.",
	"error_home_text": "Essayez de réécrire l'adresse ou réessayez plus tard.",
	"detail_title": "en détail",
	"list_event_title": "Evénements",
	"event_link": "Site officiel",
	"other_events": "Autres événements",
	"filters": "Filtres",
	"filter-group-region-type": "Type de vin et région",
	"region_default_option": "Choisissez une région",
	"filter-group-type": "Type",
	"type_default_option": "Choisir un type",
	"filter-group-flavour": "saveur",
	"filter-group-feature": "Caractéristiques du vin",
	"sweetness_default_option": "Acidité",
	"filter-group-body": "Corps",
	"body_default_option": "Choisir le corps",
	"filter-group-ingredients": "Ingrédients principaux",
	"filter-group-diets": "Intolérances",
	"filter-results": "résultats {results}",
	"filter-clear-button": "Effacer les filtres",
	"filter-apply-button": "Appliquer",
	"related_dishes": "Plats suggérés",
	"empty-title": "Aucun résultat",
	"empty-text": "Nous n'avons actuellement aucun résultat pour vous, veuillez réessayer avec de nouveaux paramètres.",
	"feedback-title": "Aidez-nous à améliorer",
	"feedback-intro": "Laissez-nous vos critiques et vos opinions afin que nous puissions améliorer Pickly pour vous.",
	"feedback-improve": "Pickly a-t-il amélioré votre expérience de restauration?",
	"feedback-error": "Veuillez choisir une option",
	"feedback-hard": "Compliqué",
	"feedback-no-help": "Ça n'a pas aidé",
	"feedback-indiferent": "Indifférent",
	"feedback-assistance": "Aidé",
	"feedback-assistance-a-lot": "Aidé suffisamment",
	"feedback-recommend": "Recommanderiez-vous à d'autres restaurants d'utiliser Pickly?",
	"feedback-no-recommend": "Ne pas recommander",
	"feedback-recommend-neutral": "Indifférent",
	"feedback-recommend-yes": "Je recommande",
	"feedback-msg": "Laissez-nous votre avis sur votre expérience et comment vous pensez que nous pourrions améliorer l'application (facultatif)",
	"feedback-submit": "Soumettre",
	"feedback-thanks-title": "Merci",
	"feedback-thanks-text": "Merci de nous aider à améliorer! Vous pouvez revenir au début en cliquant sur le bouton ci-dessous.",
	"restaurant-feedback-title": "Votre opinion compte.",
	"restaurant-feedback-subtitle": "Aidez-nous à nous améliorer.",
	"restaurant-feedback-intro": "Parlez-nous de votre expérience dans notre restaurant, en évaluant le service, la nourriture et l'environnement à travers un court questionnaire.",
	"restaurant-feedback-intro-btn": "Donnez votre avis",
	"food-feedback-title": "ALIMENTATION",
	"feed-feedback-intro": "Donnez votre avis et aidez-nous à nous améliorer.",
	"choice-question": "Le menu proposait une bonne sélection de plats",
	"presentation-question": "Les plats ont une bonne présentation",
	"tasty-question": "La nourriture était savoureuse et bien faite",
	"service-feedback-title": "Evaluation du SERVICE",
	"speed-question": "Ils ont rapidement répondu à notre demande",
	"waiters-question": "Les employés étaient amicaux et attentionnés",
	"overall-question": "Globalement, le service était bon",
	"global-feedback-title": "Évaluation GLOBALE",
	"deco-question": "Le restaurant avait une bonne ambiance et un décor",
	"price-question": "Le rapport qualité / prix était bon",
	"recommend-question": "Je recommande le restaurant à un ami",
	"comments-question": "Commentaires et suggestions",
	"recommend_title": "Recommanderiez-vous ce plat?",
	"recommend_title_drink": "Recommanderiez-vous cette boisson??",
	"recommend-total": "{total} les clients recommandent ce plat.",
	"recommend-total_drink": "{total} les clients recommandent cette boisson.",
	"type": "type",
	"body": "corps",
	"region": "région",
	"accidity": "acidité",
	"mypick-text": "Avec myPick, sélectionnez les plats, les boissons et les desserts préférés pour ce repas, puis demandez au serveur.",
	"cookie-notice": "En utilisant ce site, vous acceptez l'utilisation de cookies pour l'analyse et les statistiques.",
	"cookie-link": "Plus d'infos",
	"terms-title": "Termes et conditions",
	"cookies-title": "Politique de cookies",
	"drinks-link-all": "Voir tout",
	"toggle_list": "Liste",
	"toggle_cards": "Cartes",
	"price_under_request": "Preis auf Anfrage"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/fr-fr.json
 ** module id = 276
 ** module chunks = 0
 **/